import React from 'react';
import Script from 'next/script';
import {
  FREESTAR_PUBLISHER,
  FREESTAR_STICKY_FOOTER_MOBILE_ENABLED,
  FREESTAR_STICKY_FOOTER_MOBILE_PLACEMENT,
} from '@benzinga/ads-utils';

const FREESTAR_PUBFIG_SRC = `https://a.pub.network/${FREESTAR_PUBLISHER}/pubfig.min.js`;

const FREESTAR_QUEUE_BOOTSTRAP = `
var freestar = window.freestar || {};
freestar.queue = freestar.queue || [];
freestar.config = freestar.config || {};
freestar.config.enabled_slots = freestar.config.enabled_slots || [];
${
  FREESTAR_STICKY_FOOTER_MOBILE_ENABLED
    ? ''
    : `if (window.matchMedia('(max-width: 767px)').matches) {
  freestar.config.disabledProducts = Object.assign(freestar.config.disabledProducts || {}, { stickyFooter: true });
}`
}
window.freestar = freestar;
window.freestarReactCompontentLoaded = true;
${
  FREESTAR_STICKY_FOOTER_MOBILE_ENABLED
    ? `freestar.queue.push(function () {
  if (!window.matchMedia('(max-width: 767px)').matches) return;
  if (typeof window.freestar.newStickyFooter === 'function') {
    window.freestar.newStickyFooter(${JSON.stringify(FREESTAR_STICKY_FOOTER_MOBILE_PLACEMENT)});
  }
});`
    : ''
}
`.trim();

export const FreestarPubfig: React.FC = () => (
  <>
    <Script data-cfasync="false" id="freestar-queue" strategy="beforeInteractive">
      {FREESTAR_QUEUE_BOOTSTRAP}
    </Script>
    <Script data-cfasync="false" id="freestar-pubfig" src={FREESTAR_PUBFIG_SRC} strategy="beforeInteractive" />
  </>
);
